import axios from "axios";

export const getEvent = async () => {
  return await axios
    .get(`${process.env.REACT_APP_BASE_URL}/events`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Error retrieving events data: ${error.message}`);
    });
};

export const createEvent = async (formData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/events`,
      formData
    );

    await logService(formData.get("username"), "Create", formData.get("table"));

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateEvent = async (formData) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/events/${formData.get("id")}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    await logService(formData.get("username"), "Update", formData.get("table"));

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const softDeleteEvent = async (table, id, username) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/events/soft-delete/${id}`,
      { username: username }
    );

    await logService(username, "Soft Delete", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const softDeleteAllEvents = async (table, username) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/events/soft-delete-all`,
      { username: username }
    );

    await logService(username, "Soft Delete All", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteRowService = async (table, id, username) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/events/delete/${id}`,
      {
        params: { id },
      }
    );

    await logService(username, "Perm Delete", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAllEvents = async (table, username) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/events/delete-all`
    );

    await logService(username, "Perm Delete All", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const restoreRowService = async (table, id, username) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/events/restore/${id}`
    );

    await logService(username, "Restore", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const restoreAllEvents = async (table, type, username) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/events/restore-all`
    );

    await logService(username, "Restore All", table);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const logService = async (username, actionType, tableName) => {
  try {
    await axios.post(`${process.env.REACT_APP_BASE_URL}/logs`, {
      username,
      actionType,
      tableName,
      timestamp: new Date(),
    });
  } catch (error) {
    throw error;
  }
};
